import React from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import diversityImage from "../images/diversity-image.png";
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import careerImage from "../images/career-image.png";
import findJob from "../images/find-job.png";
import HelpIcon from '@mui/icons-material/Help';
import Tooltip from '@mui/material/Tooltip';

export const DiversityPage = (props) => {
    const {
        questions,
        selections,
        setSelections,
        diversityDict,
        setDiversityDict,
        setIsWelcome,
    } = props

    return (
        <div className="diversity-page-content">
            <div className="header-text">
                Military Information
            </div>
            <div className="question-banner-description diversity">
            We’ve put together a list of questions that can help identify resources specific to you. This information will not be shared. Please select all that apply.​
            </div>
            <div className="diversity-page-container">
                <div style={{width: "79%", display: "flex", flexDirection: "column"}}>
                    <div className="diversity-page-list">
                        {
                            Object.keys(diversityDict)?.map(diversityKey => (
                                diversityKey !== "complete" && (
                                    <div 
                                        key={diversityKey}
                                        className="diversity-page-list-item"
                                    >
                                        <div className="diversity-header">
                                            {diversityKey}
                                            {diversityDict[diversityKey]['description'] && (
                                                <Tooltip 
                                                    title={
                                                        <div className='demo-tool-tip'>
                                                            {diversityDict[diversityKey]['description']}
                                                        </div>
                                                    }
                                                    placement="top-start"
                                                    slotProps={{
                                                        tooltip: { sx: { fontSize: '1vh' } },
                                                        popper: {
                                                            modifiers: [
                                                            {
                                                                name: 'offset',
                                                                options: {
                                                                offset: [0, -14],
                                                                },
                                                            },
                                                            ],
                                                        },
                                                        }}
                                                >
                                                    <HelpIcon style={{fontSize: '1vw'}}/>
                                                </Tooltip>
                                            )}
                                        </div>
                                        <div className="diversity-options-container">
                                            {
                                                Object.keys(diversityDict[diversityKey]).map(optionKey => {
                                                    if (optionKey !== 'description') {
                                                        return (
                                                            <div
                                                                className={`diversity-option-pill ${diversityDict[diversityKey][optionKey] ? 'selected' : ''}`}
                                                                key={`${diversityKey}-${optionKey}`}
                                                                onClick={() => setDiversityDict(
                                                                    {
                                                                        ...diversityDict,
                                                                        [diversityKey]: {
                                                                            ...diversityDict[diversityKey],
                                                                            [optionKey]: !diversityDict[diversityKey][optionKey]
                                                                        }
                                                                    }
                                                                )}
                                                            >
                                                                {optionKey}
                                                            </div>
                                                        )
                                                    }
                                                })
                                            }
                                        </div>
                                    </div>
                                )
                            ))
                        }
                    </div>
                    <div className="button-container">
                        <div
                            className="next-button wide"
                            onClick={() => setDiversityDict({ ...diversityDict, complete: true})}
                        >
                            Submit
                        </div>
                    </div>
                </div>
                <div className="question-banner-image  demographics">
                    <img 
                        className="banner-image"
                        src={findJob}
                        alt="bannerImage"
                    />
                </div>
            </div>
            <div className="information-icon">
                <HelpIcon style={{fontSize: '2.6vw'}} onClick={()=>setIsWelcome('demographics')}/>
            </div>
        </div>
    )
}